module.exports = __webpack_public_path__ + "static/img/98-3.68ed264.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/98-3.jpg
// module id = PHT3
// module chunks = 0